AuthRoute = require 'mixins/authenticated-route'

App.CommunicationChannelsCommunicationChannelEditRoute = Em.Route.extend AuthRoute,
  controllerName: 'communication-channels.edit'
  templateName:   'communication-channels.edit'

  model: ->
    @modelFor('communication-channels.communication-channel')